module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid e-menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: {
        'item': true, '-active': item.active
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(item.name)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(item.title) + "\n\t\t")])
  })), _vm._v(" "), (_vm.languageSelectorIsVisible) ? _c('erco-dropdown', {
    staticClass: "lang-selector",
    attrs: {
      "size": "sm",
      "right": true,
      "currentItemIndex": _vm.selectedLangIndex,
      "items": _vm.langs
    },
    on: {
      "change": _vm.handleLanguageChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-616abda8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoMenu.vue
// module id = 625
// module chunks = 0